<template>
  <div>
    <Card dis-hover shadow>
      <div slot="title">
        <Button type="primary" to="list">返回</Button>
      </div>
      <div style="position: relative; height: 40px">
        <div class="button-container">
          <Button
            size="default"
            class="mr-1"
            v-for="(it, index) in buttonList"
            :key="it.component"
            :type="it.component == buttonindex ? 'primary' : 'default'"
            @click="buttonindex = it.component"
          >
            {{ it.text }}
          </Button>
        </div>
        <p class="title-container">
          {{
            buttonindex == "lottery-list" ? "彩票开关管理" : "外站游戏开关管理"
          }}
        </p>
      </div>
      <!-- <keep-alive> -->
      <component :is="buttonindex"></component>
      <!-- </keep-alive> -->
    </Card>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import LotteryList from './components/LotteryList'
import ElectronicGame from './components/ElectronicGame'
export default {
  components: {
    LotteryList,
    ElectronicGame
  },
  data () {
    return {
      buttonindex: 'lottery-list',
      buttonList: [
        { text: '彩票', component: 'lottery-list' },
        { text: '外站游戏', component: 'electronic-game' }
      ],
    }
  }
}
</script>
<style lang="scss">
.button-container {
  position: absolute;
}
.title-container {
  height: 28px;
  font-family: SegoeUI;
  font-size: 21px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 2;
  letter-spacing: normal;
  text-align: center;
  color: #1d3c78;
}
</style>
